<app-section-card title="Subtitles" [badge]="subtitles().length">
  @if (subtitles().length === 0) {
    <div class="px-3 py-4 text-center text-wb-muted text-[12px]">No subtitle tracks.</div>
  } @else {
    <div class="item-drop-list p-1.5">
      @for (track of subtitles(); track track.slug; let ti = $index) {
        <div class="track-item">
          <div class="item-row" (click)="toggleExpand(ti, $event)">
            <i class="pi pi-language text-[10px] text-wb-warn shrink-0"></i>
            <span class="text-[12px] font-mono font-semibold text-wb-text truncate flex-1">{{ track.label || track.slug }}</span>
            <span class="font-mono text-[10px] text-wb-muted shrink-0">{{ track.slug }}</span>
            <button pButton [text]="true" size="small" severity="secondary" class="wb-icon-btn"
              (click)="toggleExpand(ti, $event)"><i [class]="expandedTrack() === ti ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i></button>
            <button pButton [text]="true" size="small" severity="danger" class="wb-icon-btn"
              (click)="removeTrack(ti, $event)"><i class="pi pi-trash"></i></button>
          </div>
          @if (expandedTrack() === ti) {
            <div class="expanded-panel">
              <div class="form-row">
                <div class="form-field">
                  <label class="form-label">Label</label>
                  <input pInputText class="w-full" [value]="track.label" (input)="setTrackLabel(ti, $any($event.target).value)" />
                </div>
                <div class="form-field">
                  <label class="form-label">Slug</label>
                  <input pInputText class="w-full font-mono" [value]="track.slug" readonly />
                </div>
              </div>

              <div class="chapter-list">
                @for (chapter of effectiveChapters(); track chapter.slug) {
                  <div class="form-row chapter-row">
                    <span class="chapter-name">{{ chapter.name || chapter.slug }}</span>
                    <div class="picker-row">
                      <input pInputText class="flex-1" readonly [value]="fileNameFor(track.slug, chapter.slug) ?? '— none —'" />
                      <button class="picker-btn" type="button" (click)="openChapterPicker(track.slug, chapter.slug)" title="Browse subtitle files">
                        <i class="pi pi-folder-open text-xs"></i>
                      </button>
                      @if (fileNameFor(track.slug, chapter.slug)) {
                        <button class="picker-btn" type="button" (click)="clearChapterFile(track.slug, chapter.slug, $event)" title="Clear">
                          <i class="pi pi-times text-xs"></i>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="px-3 py-2">
    <button class="add-item-btn" type="button" (click)="addTrack()"><i class="pi pi-language text-[9px]"></i> Add Subtitle Track</button>
  </div>
</app-section-card>

<app-media-picker
  [(visible)]="pickerVisible"
  [categories]="pickerCategories"
  [currentValue]="pickerCurrentValue()"
  (fileSelected)="onChapterFilePicked($event)"
/>
